import { DAY_MONTH_YEAR, LABELMONTH } from '@/libs/filterDate'
import { today } from '@/store/helpers'

// eslint-disable-next-line import/prefer-default-export
export function getFormattedDateRange(startDate, endDate) {
  if (!startDate || !endDate) {
    return 'Tentukan Tanggal'
  }

  const start = new Date(startDate)
  const end = new Date(endDate)

  if (
    start.getDate() === 1
      && end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate()
  ) {
    if (
      start.getMonth() === today.getMonth()
        && start.getFullYear() === today.getFullYear()
    ) {
      return 'Bulan Ini'
    }
    return `${LABELMONTH[start.getMonth()]} ${start.getFullYear()}`
  }
  return `${DAY_MONTH_YEAR(start)} - ${DAY_MONTH_YEAR(end)}`
}
